import React from 'react';
import { ArrowRightIcon } from '@/components/Icons';

interface ForwardButtonProps {
    href?: string;
    className?: string;
    onClick?: () => void;
    text?: string;
}

export const ForwardButton: React.FC<ForwardButtonProps> = ({
    href,
    className = '',
    onClick,
    text = 'Forts�t',
}) => {
    const commonClasses =
        'forward-button group inline-flex items-center justify-start gap-2';

    const content = (
        <>
            <span className="mr-2">{text}</span>

            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gray-100 transition-colors duration-150">
                <ArrowRightIcon />
            </span>
        </>
    );

    const classes = `${commonClasses} ${className}`;

    if (href) {
        return (
            <a href={href} className={classes}>
                {content}
            </a>
        );
    }

    return (
        <button className={classes} onClick={onClick} type="button">
            {content}
        </button>
    );
};
